/**
 * The CMS branch the Designer reads and writes CMS items on, or null for main.
 * Comes from `?cmsBranchId=` on the Designer URL until the loaded site branch
 * carries its CMS branch id.
 */
export function getCMSBranchId(): string | null {
  return new URLSearchParams(window.location.search).get('cmsBranchId');
}
